export default "__VITE_ASSET__64d1d14d__"